<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT IMAGE ORDER
      </h6>
      <EditCategoryDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <AddCategorySidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <div class="flex  justify-between  items-center">
      <div>
        <h2 class="text-2xl font-semibold">
          Add Sub-Category
        </h2>
        <!-- 
        <small class=" text-muted "
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        </small> -->
      </div>
      <base-button outline type="success" class="flex" @click="addBanner">
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> Add
        Sub-Category
      </base-button>
    </div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="CategoryData"
    >
      <el-table-column
        label="Sub-Cat ID"
        prop="CategoryData"
        min-width="140px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.CategoryData }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Name" min-width="150px" prop="name" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Categories"
        min-width="180px"
        prop="categorylist"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.categorylist }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Status" min-width="140px" prop="status" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.Status }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Action" min-width="150px">
        <div class="flex items-center">
          <div class="flex items-center mr-4 cursor-pointer">
            <feather-icon
              @click="editModal = true"
              block
              icon="EditIcon"
              svgClasses="w-5"
              data-toggle="tooltip"
              data-placement="top"
              title="Edit"
            ></feather-icon>
          </div>
          <div class="flex items-center cursor-pointer">
            <feather-icon
              icon="TrashIcon"
              svgClasses="w-5 "
              data-toggle="tooltip"
              data-placement="top"
              title="Delete"
            ></feather-icon>
          </div>
        </div>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import CategoryData from "./components/CategoryData";
import EditCategoryDetail from "./components/EditCategoryDetail";
import AddCategorySidebar from "./components/AddCategorySidebar";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditCategoryDetail,
    AddCategorySidebar
  },
  data() {
    return {
      CategoryData,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
